import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService {
    localhost: boolean;
    dev: boolean;
    acp: boolean;

    constructor() {
        this.localhost = window.location.host.indexOf('localhost') > -1;
        this.dev = window.location.host.indexOf('ca.dev') > -1;
        this.acp = window.location.host.indexOf('acp-') > -1;
    }

    public getWebApiEndpoint() {
        return this.localhost ? 'http://localhost:47669/v1/' : this.dev ? 'https://acp-ca.br.scania.com/api/v1/' : this.acp ? 'https://' + window.location.hostname + '/api/v1/' : 'http://' + window.location.hostname + '/api/v1/';
    }

    public getSlaUrl() {
        return this.localhost || this.acp ? 'http://acp-slainhouse.br.scania.com:7778/horn/' : 'http://slainhouse.br.scania.com:7778/ca/';
    }
}

